<template>
  <div class="container">
    <div class="title">{{$t(title)}}</div>
    <div class="panel">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ui-panel',
  props:{
    title:{default:""}
  },
  data:function(){
    return {
    
    }
  },
  computed:{
  }
 
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  margin-bottom:15px;
  position:relative;
  border:1px solid #707070;
  border-radius:4px;
  outline: none;
   -webkit-appearance: none;
  -moz-appearance: none;
  background-color:#FFFFFF;
}
.title{
  padding:0 5px;
  position:absolute;
  font-size:.7em;
  display:inline-block;
  background-color:#FFFFFF;
  top: -8px;
  left: 5px;
}

.panel{
  width:100%;
  
  font-size:1.0em;
  padding:8px 10px;
  
 
}


</style>
